import type { NewBookV1 } from '@ilteducation/content-registry-types';
import type { AlternativeName, ContributorNameComponents } from '@ilteducation/content-ref-data-types';

/** The book fields that hold creators. */
export const CREATOR_ROLES = [
  'authors',
  'illustrators',
  'translators',
  'narrators',
  'editors',
  'coverDesigners',
  'adapters',
] as const satisfies readonly (keyof NewBookV1)[];

export type CreatorRole = (typeof CREATOR_ROLES)[number];

/**
 * One creator row in the book form. The name is edited as contributor name
 * components and merged into the two-part content-registry `Person` on the way
 * out (see `fieldRemapper`). `contributorId` stays empty until the row is
 * linked - either by picking a contributor from the search results, or by
 * creating one when the book is saved.
 */
export type BookCreatorDraft = ContributorNameComponents & {
  /** Generated by ArrayInput for drag tracking, not part of the payload. */
  id?: string;
  contributorId?: string;
  /** How a saved book carries the components; the form edits the flat ones. */
  nameComponents?: ContributorNameComponents;
  alternativeNames?: AlternativeName[];
  /** Narrators only. */
  language?: string;
};

export type BookCreators = {
  [role in CreatorRole]?: BookCreatorDraft[];
};
